module.exports = __webpack_public_path__ + "img/bjzhibo.2827fb4b.png";